import Switch from '@mui/material/Switch'
import { Dropdown, Form } from 'react-bootstrap'
import 'react-dropdown/style.css'
import { v4 as uuidv4 } from 'uuid';
import ReplyIcon from '@mui/icons-material/Reply'
import { useEffect, useState } from 'react'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { useDispatch, useSelector } from 'react-redux'
import { showDangerToast, showToast } from '../../constants/toaster'
import { updateLoading } from '../../../redux/features/common/commonSlice'


const label = { inputProps: { 'aria-label': 'Size switch demo' } }
const options = [
  { value: '', label: 'Select User' },
  { value: '1', label: 'Ganesh' }
]

export const AddNetworkProvider = props => {
  const [countryDropdownText, setCountryDropdownText] = useState({
    id: '',
    lable: 'Select Country'
  })
  const [countryCodeList, setCountryCodeList] = useState([
    {
      id: '',
      name: 'Select Country'
    }
  ])
  const [paidNetwork, setPaidNetwork] = useState(false)
  const dispatch = useDispatch()
  const [notificationTitle, setNotificationTitle] = useState('')
  const [notificationBody, setNotificationBody] = useState('')
  const userData = useSelector((state) => state?.userData);
  const getCountryCodeList = async () => {
    try {
      dispatch(updateLoading(true))
      let path = urls.countryCodeList
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        let tempArray = []
        tempArray.push(...response?.data)
        setCountryCodeList(tempArray)
        for (let i = 0; i < tempArray?.length; i++) {
          if (tempArray[i]?.id === props?.networkProviderDetails?.countryId) {
            setCountryDropdownText({
              id: tempArray[i]?.id,
              lable: tempArray[i]?.name
            })
            break;
          }
        }
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  useEffect(() => {
    getCountryCodeList()
    if (props?.networkProviderDetails) {
      setNotificationTitle(props?.networkProviderDetails?.isp)
      setNotificationBody(JSON.parse(props?.networkProviderDetails?.ipRange)?.join(","))
      setPaidNetwork(props?.networkProviderDetails?.paid)
    }
  }, [])

  const processNetworkProvider = async () => {
    if (notificationTitle?.trim() && notificationBody && countryDropdownText?.id) {
      const IPRangeArray = notificationBody?.replace(/\s+/g, '')?.split(",");
      if (!IPRangeArray?.length) {
        showDangerToast("IP Range is require.")
      } else {
        if (IPRangeArray?.[0] === '') {
          showDangerToast("IP Range is require.")
        } else {

          try {
            dispatch(updateLoading(true));
            let postJson = {
              id: props?.networkProviderDetails?.id,
              countryId: countryDropdownText?.id,
              isp: notificationTitle?.trim(),
              org: notificationTitle?.trim(),
              ipRange: IPRangeArray,
              paid: paidNetwork
            }
            let path = urls.addNetworkServiceProvider;
            let res = await ApiCaller.post(postJson, path, userData?.access_token);
            const response = await res.response.json();
            if (response.status == 200) {
              dispatch(updateLoading(false));
              props?.setAddNewNotification(false)
              props?.setCallAPi(uuidv4())
            } else {
              dispatch(updateLoading(false));
              showDangerToast(response.message);
            }
          } catch (error) {
            dispatch(updateLoading(false));
            console.error(error);
            showDangerToast(error.message);
          }
        }
      }
    } else {
      showDangerToast("Fill All Require Fields")
    }
  }

  return (
    <>
      <div className='container-fluid mt--7'>
        <div className='row'>
          <div className='col text-left'>
            <div className='card shadow'>
              <div className='card-header border-0'>
                <div className='row align-items-center '>
                  <div className='col text-left'>
                    <a
                      onClick={() => props.setAddNewNotification(false)}
                      className='btn btn-sm btn-primary text-white'
                    >
                      <ReplyIcon />
                      Cancel
                    </a>
                  </div>
                  <div className='col text-center'>
                    <h3 className='mb-0'> {props?.networkProviderDetails?.id ? 'Update' : 'Add'} Network Provider</h3>
                  </div>
                  <div className='col text-right'>
                    <a
                      onClick={() => processNetworkProvider()}
                      // onClick={props.sendNotification}
                      className='btn btn-sm btn-primary text-white'
                    >
                      {props?.networkProviderDetails?.id ? 'Update' : 'Add'}
                    </a>
                  </div>
                </div>
              </div>

              <div className='card-header border-0'>
                <div className='row align-items-center justify-content-center '>
                  <div className='col-md-6'>
                    <Form>
                      <Form.Group
                        className='mb-3'
                        controlId='exampleForm.ControlInput1'
                      >
                        <Form.Label>Provider Name*</Form.Label>
                        <Form.Control type='text' placeholder='Title' value={notificationTitle} onChange={(e) => setNotificationTitle(e.target.value)} />
                      </Form.Group>
                    </Form>
                  </div>
                </div>
                <div className='row align-items-center justify-content-center '>
                  <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <Form>
                          <Form.Group
                            className='mb-3' style={{ display: 'grid' }}
                            controlId='exampleForm.ControlInput1'
                          >
                            <Form.Label>Country*</Form.Label>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant='success'
                                style={{
                                  backgroundColor: 'white',
                                  color: 'black',
                                  border: '1px solid #cad1d7',
                                  boxShadow: 'none',
                                  transform: 'none'
                                }}
                                id='dropdown-basic'
                              >
                                {countryDropdownText?.lable}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {countryCodeList?.map((item, i) => {
                                  return (
                                    <>
                                      <Dropdown.Item
                                        eventKey={item?.id}
                                        onClick={() => {
                                          setCountryDropdownText({
                                            id: item?.id,
                                            lable: item?.name
                                          })
                                        }}
                                      >
                                        {item?.name}
                                      </Dropdown.Item>
                                    </>
                                  )
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                        </Form>

                      </div>
                      <div className='col-md-6'>
                        <Form>
                          <Form.Group
                            className='mb-3' style={{ display: 'grid' }}
                            controlId='exampleForm.ControlInput1'
                          >
                            <Form.Label>Paid</Form.Label>
                            <Switch
                              {...label}
                              checked={paidNetwork}
                              onChange={e =>
                                setPaidNetwork(e?.target?.checked)
                              }
                              size='small'
                            />
                          </Form.Group>
                        </Form>
                      </div>
                    </div>

                  </div>
                </div>
                <div className='row align-items-center justify-content-center mt-3'>
                  <div className='col-md-6'>
                    <Form>
                      <Form.Group
                        className='mb-3' style={{ display: 'grid' }}
                        controlId='exampleForm.ControlInput1'
                      >
                        <Form.Label>IP Range*</Form.Label>
                        <textarea
                          rows={6}
                          placeholder='IP Range'
                          value={notificationBody}
                          onChange={(e) => setNotificationBody(e.target.value)}
                          style={{
                            width: '100%',
                            padding: '8px 12px',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            boxShadow: '0px 2px 2px #f0f0f0',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '14px',
                          }}
                        />
                      </Form.Group>
                    </Form>

                    <span>Note: IP Range Should be comma seperated</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
